'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.fileNameWidget = function (pageController, metadataSynchronizer, opts) {
	const autosizeInput = require('autosize-input'),
		options = opts || {},
		ENTER = 13,
		ESC = 27;
	return mmWidgets.each(this, function () {
		let currentValue;
		const element = this,
			domEl = this.domElements[0],
			triggerInput = function () {
				const evt = document.createEvent('HTMLEvents');
				evt.initEvent('input', true, false);
				domEl.dispatchEvent(evt);
			},
			doDisable = function (val) {
				if (!options.readOnly) {
					element.attr('disabled', val);
				}
				if (val) {
					element.addClass('in-progress');
				} else {
					element.removeClass('in-progress');
				}
			},
			wireHtmlEditingEvents = function () {
				element.on('focus', function () {
					currentValue = element.val();
				}).on('blur', function () {
					const targetName = element.val().trim();
					if (targetName.length === 0) {
						element.val(currentValue);
						triggerInput();
					} else if (targetName !== currentValue || element.hasClass('error')) {
						pageController.renameFile(targetName);
					}
				}).on('keyup', function (e) {
					if (e.keyCode === ENTER) {
						element.blur();
					} else if (e.keyCode === ESC) {
						element.val(currentValue);
						triggerInput();
						element.blur();
					}
				});
			},
			updateTitle = function (newTitle) {
				if (currentValue !== newTitle) {
					currentValue = newTitle;
					element.val(newTitle);
					triggerInput();
				}
			};
		autosizeInput(domEl, { minWidth: true });
		pageController.addEventListener('fileLoaded', function (fileId, title) {
			doDisable(false);
			element.removeClass('error').addClass('active');
			updateTitle(title);
		});
		pageController.addEventListener('renameFailed', function () {
			doDisable(false);
			element.addClass('error');
		});
		pageController.addEventListener('renamingFile', function () {
			doDisable(true);
			element.removeClass('renamed');
			element.removeClass('error');
		});
		pageController.addEventListener('renamed', function (newName) {
			doDisable(false);
			element.removeClass('error');
			element.addClass('renamed');
			if (newName) {
				updateTitle(newName);
			}
		});

		if (metadataSynchronizer) {
			metadataSynchronizer.addEventListener('title', updateTitle);
		}
		if (!options.readOnly) {
			wireHtmlEditingEvents();
		} else {
			element.attr({'disabled': true, tabIndex: ''});
		}
	});
};
